import { gql } from '@apollo/client';

const GET_USERS_ASSIGNABLE_TO_TASK_LIST_QUERY = gql`
  query GetUsersAssignableToTaskList(
    $taskListId: ID!
    $query: String
    $after: String
  ) {
    viewer {
      id
      usersAssignableToTaskList(
        taskListId: $taskListId
        query: $query
        after: $after
      ) {
        nodes {
          id
          emailAddress
          firstName
          lastName
          userRole
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export default GET_USERS_ASSIGNABLE_TO_TASK_LIST_QUERY;
